import ModulPembelajaran from "@/modules/modul_belajar_2022/components/ModulBelajar";
import ModulPembelajaranForm from "@/modules/modul_belajar_2022/components/Form";
import ModulPembelajaranReport from "@/modules/modul_belajar_2022/components/ModulReport";
import ModulReportDetail from "../components/ModulReportDetail.vue";

export default [
    {
        path: "/modul-pembelajaran",
        name: "ModulPembelajaran",
        component: ModulPembelajaran,
    },
    {
        path: "/modul-pembelajaran/form",
        name: "ModulPembelajaranForm",
        component: ModulPembelajaranForm,
    },
    {
        path: "/modul-pembelajaran/report",
        name: "ModulPembelajaranReport",
        component: ModulPembelajaranReport,
    },
    {
        path: "/modul-pembelajaran/report/detail",
        name: "ModulReportDetail",
        component: ModulReportDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/modul_belajar_2022/router/modul_belajar.js